import React from "react";
import {
  Trophy, Activity, Footprints, Stethoscope, Briefcase,
  HeartHandshake, Syringe, Dumbbell, Bone,
} from "lucide-react";

const map = {
  trophy: Trophy,
  spine: Bone,
  activity: Activity,
  footprints: Footprints,
  stethoscope: Stethoscope,
  briefcase: Briefcase,
  "heart-handshake": HeartHandshake,
  syringe: Syringe,
  dumbbell: Dumbbell,
};

export default function ServiceIcon({ name, className = "h-6 w-6" }) {
  const Icon = map[name] || Activity;
  return <Icon className={className} />;
}
